var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var lib = "";
var render$b = function() {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("button", _vm._g(_vm._b({ class: (_obj = {}, _obj[_vm.$style.button] = true, _obj[_vm.$style.buttonPreloader] = _vm.loading, _obj), attrs: { "type": _vm.type, "disabled": _vm.loading } }, "button", _vm.$attrs, false), _vm.$listeners), [_vm.loading ? _c("svg", { class: _vm.$style.spinner, attrs: { "width": "20", "height": "20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "opacity": ".5", "d": "M10 1a8.983 8.983 0 0 0-7 3.343A9 9 0 1 0 19 10c0-1.052-.18-2.062-.512-3a8.996 8.996 0 0 0-1.821-3.046", "stroke": "#9C9C9C", "stroke-width": "1.5" } })]) : _vm._t("default")], 2);
};
var staticRenderFns$b = [];
const button = "_button_1aud0_46";
const buttonPreloader = "_buttonPreloader_1aud0_79";
const spinner = "_spinner_1aud0_93";
var __style0$b = {
  button,
  buttonPreloader,
  spinner,
  "spinner-animation": "_spinner-animation_1aud0_1"
};
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles2, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles2) {
        injectStyles2.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles2) {
    hook = shadowMode ? function() {
      injectStyles2.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles2;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const script$b = {
  name: "BaseButton",
  props: {
    type: {
      type: String,
      default: "button"
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
const __cssModules$b = {};
__cssModules$b["$style"] = __style0$b;
var __component__$b = /* @__PURE__ */ normalizeComponent(script$b, render$b, staticRenderFns$b, false, injectStyles$b, null, null, null);
function injectStyles$b(context) {
  for (let o in __cssModules$b) {
    this[o] = __cssModules$b[o];
  }
}
var baseButton = /* @__PURE__ */ function() {
  return __component__$b.exports;
}();
var render$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tagName, _vm._b({ tag: "component", class: _vm.$style["size-" + _vm.size] }, "component", _vm.$attrs, false), [_vm._t("default")], 2);
};
var staticRenderFns$a = [];
var __style0$a = {
  "size-display": "_size-display_ab35v_38",
  "size-1": "_size-1_ab35v_46",
  "size-2": "_size-2_ab35v_54",
  "size-3": "_size-3_ab35v_62",
  "size-4": "_size-4_ab35v_70",
  "size-5": "_size-5_ab35v_78",
  "size-6": "_size-6_ab35v_86"
};
const sizes = ["1", "2", "3", "4", "5", "6", "display"];
const script$a = {
  inheritAttrs: false,
  name: "HuntKitHeading",
  props: {
    size: {
      type: String,
      required: true,
      validator(value) {
        return sizes.includes(value);
      }
    },
    level: {
      type: Number,
      required: true,
      validator(value) {
        return value >= 1 && value <= 6;
      }
    }
  },
  computed: {
    tagName() {
      return `h${this.level}`;
    }
  }
};
const __cssModules$a = {};
__cssModules$a["$style"] = __style0$a;
var __component__$a = /* @__PURE__ */ normalizeComponent(script$a, render$a, staticRenderFns$a, false, injectStyles$a, null, null, null);
function injectStyles$a(context) {
  for (let o in __cssModules$a) {
    this[o] = __cssModules$a[o];
  }
}
var baseHeading = /* @__PURE__ */ function() {
  return __component__$a.exports;
}();
var render$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, { tag: "component", class: _vm.secondary ? _vm.$style.secondary : _vm.$style.text }, [_vm._t("default")], 2);
};
var staticRenderFns$9 = [];
const text = "_text_1k1jb_21";
const secondary = "_secondary_1k1jb_30 _text_1k1jb_21";
var __style0$9 = {
  text,
  secondary
};
const script$9 = {
  name: "HuntKitText",
  props: {
    tag: {
      type: String,
      default: "span"
    },
    secondary: Boolean
  }
};
const __cssModules$9 = {};
__cssModules$9["$style"] = __style0$9;
var __component__$9 = /* @__PURE__ */ normalizeComponent(script$9, render$9, staticRenderFns$9, false, injectStyles$9, null, null, null);
function injectStyles$9(context) {
  for (let o in __cssModules$9) {
    this[o] = __cssModules$9[o];
  }
}
var baseText = /* @__PURE__ */ function() {
  return __component__$9.exports;
}();
var render$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: _vm.vertical ? _vm.$style.verticalSpacer : _vm.$style.horizontalSpacer, style: _vm.style });
};
var staticRenderFns$8 = [];
const horizontalSpacer = "_horizontalSpacer_nv6yq_26";
const verticalSpacer = "_verticalSpacer_nv6yq_30";
var __style0$8 = {
  horizontalSpacer,
  verticalSpacer
};
const script$8 = {
  name: "HuntKitSpacer",
  props: {
    size: {
      type: String,
      required: true
    },
    vertical: Boolean
  },
  computed: {
    style() {
      return {
        "--size": 10
      };
    }
  }
};
const __cssModules$8 = {};
__cssModules$8["$style"] = __style0$8;
var __component__$8 = /* @__PURE__ */ normalizeComponent(script$8, render$8, staticRenderFns$8, false, injectStyles$8, null, null, null);
function injectStyles$8(context) {
  for (let o in __cssModules$8) {
    this[o] = __cssModules$8[o];
  }
}
var baseSpace = /* @__PURE__ */ function() {
  return __component__$8.exports;
}();
var render$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("input", _vm._g(_vm._b({ class: _vm.className }, "input", _vm.$attrs, false), _vm.listeners));
};
var staticRenderFns$7 = [];
const input = "_input_t04iz_40";
const invalid$2 = "_invalid_t04iz_69";
var __style0$7 = {
  input,
  invalid: invalid$2
};
const script$7 = {
  inheritAttrs: false,
  name: "HuntKitInput",
  model: {
    prop: "value",
    event: "inputValue"
  },
  props: {
    invalid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      return {
        [this.$style.input]: true,
        [this.$style.invalid]: this.invalid
      };
    },
    listeners() {
      return __spreadProps(__spreadValues({}, this.$listeners), {
        input: (event) => {
          this.$emit("inputValue", event.target.value);
          this.$emit("input", event);
        }
      });
    }
  }
};
const __cssModules$7 = {};
__cssModules$7["$style"] = __style0$7;
var __component__$7 = /* @__PURE__ */ normalizeComponent(script$7, render$7, staticRenderFns$7, false, injectStyles$7, null, null, null);
function injectStyles$7(context) {
  for (let o in __cssModules$7) {
    this[o] = __cssModules$7[o];
  }
}
var baseInput = /* @__PURE__ */ function() {
  return __component__$7.exports;
}();
var render$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("select", _vm._g(_vm._b({ class: _vm.className }, "select", _vm.$attrs, false), _vm.listeners), [_vm._t("default")], 2);
};
var staticRenderFns$6 = [];
const select = "_select_10ewf_42";
const invalid$1 = "_invalid_10ewf_76";
var __style0$6 = {
  select,
  invalid: invalid$1
};
const script$6 = {
  inheritAttrs: false,
  name: "HuntKitSelect",
  model: {
    prop: "value",
    event: "inputValue"
  },
  props: {
    invalid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      return {
        [this.$style.select]: true,
        [this.$style.invalid]: this.invalid
      };
    },
    listeners() {
      return __spreadProps(__spreadValues({}, this.$listeners), {
        input: (event) => {
          this.$emit("inputValue", event.target.value);
          this.$emit("input", event);
        }
      });
    }
  }
};
const __cssModules$6 = {};
__cssModules$6["$style"] = __style0$6;
var __component__$6 = /* @__PURE__ */ normalizeComponent(script$6, render$6, staticRenderFns$6, false, injectStyles$6, null, null, null);
function injectStyles$6(context) {
  for (let o in __cssModules$6) {
    this[o] = __cssModules$6[o];
  }
}
var baseSelect = /* @__PURE__ */ function() {
  return __component__$6.exports;
}();
var render$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("textarea", _vm._g(_vm._b({ class: _vm.className }, "textarea", _vm.$attrs, false), _vm.listeners));
};
var staticRenderFns$5 = [];
const textarea = "_textarea_xz8ip_41";
const invalid = "_invalid_xz8ip_70";
var __style0$5 = {
  textarea,
  invalid
};
const script$5 = {
  inheritAttrs: false,
  name: "HuntKitTextarea",
  model: {
    prop: "value",
    event: "inputValue"
  },
  props: {
    invalid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    className() {
      return {
        [this.$style.textarea]: true,
        [this.$style[`size-${this.size}`]]: true,
        [this.$style.invalid]: this.invalid
      };
    },
    listeners() {
      return __spreadProps(__spreadValues({}, this.$listeners), {
        input: (event) => {
          this.$emit("inputValue", event.target.value);
          this.$emit("input", event);
        }
      });
    }
  }
};
const __cssModules$5 = {};
__cssModules$5["$style"] = __style0$5;
var __component__$5 = /* @__PURE__ */ normalizeComponent(script$5, render$5, staticRenderFns$5, false, injectStyles$5, null, null, null);
function injectStyles$5(context) {
  for (let o in __cssModules$5) {
    this[o] = __cssModules$5[o];
  }
}
var baseTextarea = /* @__PURE__ */ function() {
  return __component__$5.exports;
}();
let nanoid = (size = 21) => {
  let id = "";
  let bytes = crypto.getRandomValues(new Uint8Array(size));
  while (size--) {
    let byte = bytes[size] & 63;
    if (byte < 36) {
      id += byte.toString(36);
    } else if (byte < 62) {
      id += (byte - 26).toString(36).toUpperCase();
    } else if (byte < 63) {
      id += "_";
    } else {
      id += "-";
    }
  }
  return id;
};
var render$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("label", { class: _vm.$style.label }, [_vm._t("default"), _vm.description ? [_c("div", { class: _vm.$style.description }, [_vm._v(_vm._s(_vm.description))])] : _vm._e()], 2);
};
var staticRenderFns$4 = [];
const label = "_label_jpk8n_23";
const description = "_description_jpk8n_32";
var __style0$4 = {
  label,
  description
};
const script$4 = {
  name: "HuntKitFormLabel",
  props: {
    description: {
      type: String,
      default: null
    }
  }
};
const __cssModules$4 = {};
__cssModules$4["$style"] = __style0$4;
var __component__$4 = /* @__PURE__ */ normalizeComponent(script$4, render$4, staticRenderFns$4, false, injectStyles$4, null, null, null);
function injectStyles$4(context) {
  for (let o in __cssModules$4) {
    this[o] = __cssModules$4[o];
  }
}
var FormLabel = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var render$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: _vm.$style.error }, [_vm._t("default")], 2);
};
var staticRenderFns$3 = [];
const error = "_error_19g2r_12";
var __style0$3 = {
  error
};
const script$3 = {
  name: "HuntKitFormError"
};
const __cssModules$3 = {};
__cssModules$3["$style"] = __style0$3;
var __component__$3 = /* @__PURE__ */ normalizeComponent(script$3, render$3, staticRenderFns$3, false, injectStyles$3, null, null, null);
function injectStyles$3(context) {
  for (let o in __cssModules$3) {
    this[o] = __cssModules$3[o];
  }
}
var FormError = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: _vm.className }, [_vm.label ? _c("form-label", { attrs: { "for": _vm.id, "description": _vm.description } }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._t("default", null, { "id": _vm.id }), _vm.error ? _c("form-error", { class: _vm.$style.error }, [_vm._v(_vm._s(_vm.error))]) : _vm.hint ? _c("div", { class: _vm.$style.hint, domProps: { "innerHTML": _vm._s(_vm.hint) } }) : _vm._e()], 2);
};
var staticRenderFns$2 = [];
const field = "_field_1djb5_56";
const hint = "_hint_1djb5_66";
var __style0$2 = {
  field,
  hint
};
const script$2 = {
  name: "HuntKitFormField",
  components: {
    FormLabel,
    FormError
  },
  props: {
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    error: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      id: `field-${nanoid()}`
    };
  },
  computed: {
    className() {
      return {
        [this.$style.field]: true,
        [this.$style.labeled]: Boolean(this.label)
      };
    }
  }
};
const __cssModules$2 = {};
__cssModules$2["$style"] = __style0$2;
var __component__$2 = /* @__PURE__ */ normalizeComponent(script$2, render$2, staticRenderFns$2, false, injectStyles$2, null, null, null);
function injectStyles$2(context) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
var formField = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var render$1 = function() {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: (_obj = {}, _obj[_vm.$style.root] = true, _obj[_vm.$style.fill] = _vm.fill, _obj) }, [_c("div", { class: _vm.$style.left }, [_vm._t("default")], 2), _c("div", { class: _vm.$style.right }, [_vm._t("right")], 2)]);
};
var staticRenderFns$1 = [];
const root = "_root_wd5yt_25";
const left = "_left_wd5yt_32";
const right = "_right_wd5yt_33";
const fill = "_fill_wd5yt_38";
var __style0$1 = {
  root,
  left,
  right,
  fill
};
const script$1 = {
  name: "HuntKitFormFooter",
  props: {
    fill: {
      type: Boolean,
      default: false
    }
  }
};
const __cssModules$1 = {};
__cssModules$1["$style"] = __style0$1;
var __component__$1 = /* @__PURE__ */ normalizeComponent(script$1, render$1, staticRenderFns$1, false, injectStyles$1, null, null, null);
function injectStyles$1(context) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var formFooter = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: _vm.$style.divider });
};
var staticRenderFns = [];
const divider = "_divider_1p6kt_12";
var __style0 = {
  divider
};
const script = {
  name: "HuntKitFormDivider"
};
const __cssModules = {};
__cssModules["$style"] = __style0;
var __component__ = /* @__PURE__ */ normalizeComponent(script, render, staticRenderFns, false, injectStyles, null, null, null);
function injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var formDivider = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export { baseButton as BaseButton, baseHeading as BaseHeading, baseInput as BaseInput, baseSelect as BaseSelect, baseSpace as BaseSpace, baseText as BaseText, baseTextarea as BaseTextarea, formDivider as FormDivider, formField as FormField, formFooter as FormFooter };
